import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.097 0q1.419 0 2.322.607a5 5 0 0 1 1.484 1.552 5.85 5.85 0 0 1 .904 2.36Q20 5.801 20 6.611q0 3.306-1.613 6.004T13.355 17l-.58-1.214q2-.877 3.418-2.766 1.484-1.89 1.484-3.845 0-.81-.193-1.417a3.58 3.58 0 0 1-2.387.877 4.1 4.1 0 0 1-2.904-1.147q-1.225-1.146-1.225-3.17 0-1.89 1.226-3.104T15.097 0M4.129 0q1.419 0 2.323.607A5 5 0 0 1 7.935 2.16q.71 1.08.904 2.36.193 1.282.193 2.092 0 3.306-1.613 6.004t-5.032 4.385l-.58-1.214q2-.88 3.418-2.767 1.484-1.89 1.484-3.845 0-.81-.194-1.417a3.58 3.58 0 0 1-2.387.877 4.1 4.1 0 0 1-2.903-1.147Q.001 6.342 0 4.318q0-1.89 1.226-3.104T4.129 0"
    }, null, -1)
  ]))]))
}
export default { render: render }